import { Validator } from "../validator"

enum BankNameError {
    Blank = `bank_name_error`,
}

class BankNameValidator implements Validator<string, BankNameError> {
    validate(entry: string): BankNameError | undefined {
        if (entry === ``) {
            return BankNameError.Blank
        }
        return undefined
    }
}

export { BankNameValidator }